import { render } from "./GameDescription.vue?vue&type=template&id=e4d19c6a&scoped=true"
import script from "./GameDescription.vue?vue&type=script&lang=js"
export * from "./GameDescription.vue?vue&type=script&lang=js"

import "./GameDescription.vue?vue&type=style&index=0&id=e4d19c6a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-e4d19c6a"

export default script